export const ZELLO_BASE_URL = 'wss://zellowork.io/ws/'
